(function () {
var initialized = false;

function initCarousel() {
    var track = document.querySelector('.cart-recommend__track');
    if (!track || initialized) return;
    initialized = true;

    /* Reset any leftover transform from old JS */
    track.style.transform = 'none';
    track.style.transition = 'none';

    /* Mouse drag-to-scroll for desktop */
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
        isDown = true;
        track.style.cursor = 'grabbing';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        e.preventDefault();
    });

    track.addEventListener('mouseleave', function () {
        isDown = false;
        track.style.cursor = 'grab';
    });

    track.addEventListener('mouseup', function () {
        isDown = false;
        track.style.cursor = 'grab';
    });

    track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
    });

    track.style.cursor = 'grab';
}

/* Try immediately */
initCarousel();

/* Re-init whenever cart drawer re-renders */
var observer = new MutationObserver(function () {
    initialized = false;
    initCarousel();
});

observer.observe(document.body, { childList: true, subtree: true });
})();

/* ========== PB Cart Rewards Bar ========== */
(function () {
  var _rc = window.pbRewardCodes || {};
  var REWARDS = [
    { min: 3, pct: 10, code: _rc.code10 || 'SPOOKY10' },
    { min: 4, pct: 15, code: _rc.code15 || 'SPOOKY15' },
    { min: 5, pct: 20, code: _rc.code20 || 'SPOOKY20' }
  ];
  /* Handle of the gift-box add-on: excluded from tier qty + discount,
     but kept in cart total display. Must match the Shopify product handle. */
  var GIFT_BOX_HANDLE = 'wrapped-gift-box';
  /* PBB Personalizer (PM 06/10/2026): dòng phí nâng size bộ quà — tiền vẫn cộng vào tổng, nhưng KHÔNG phải một món */
  var PBB_FEE_HANDLE = 'gift-set-size-upgrade';
  var FREE_SHIP_CENTS = 15000; // $150
  var FREE_GIFT_CENTS = 15000; // $150 (kept for rewards bar milestone display)

  function getReward(n) {
    var r = null;
    REWARDS.forEach(function (x) { if (n >= x.min) r = x; });
    return r;
  }

  function updateRewardsBar() {
    var bar = document.getElementById('pb-cart-rewards');
    if (!bar) return;

    /* Force visible — something external may be hiding this element */
    bar.style.removeProperty('display');
    bar.removeAttribute('aria-hidden');

    var items        = parseInt(bar.dataset.itemCount)    || 0;
    var totalCents   = parseInt(bar.dataset.cartTotal)    || 0;
    var originalCents= parseInt(bar.dataset.originalTotal)|| totalCents;
    var reward       = getReward(items);
    var savedCents   = originalCents - totalCents;
    var discTotal    = totalCents;

    /* ── Bar fill (%) — 3 tiers: 3/4/5 items ── */
    var pct;
    if (items >= 5) {
      pct = 100;
    } else if (items >= 4) {
      pct = 66;
    } else if (items >= 3) {
      pct = 33;
    } else if (items >= 1) {
      pct = 10;
    } else {
      pct = 0;
    }
    var fill = bar.querySelector('.pb-rewards__fill');
    if (fill) fill.style.width = Math.min(pct, 100).toFixed(1) + '%';

    /* ── Step active states ── */
    var reached = [
      items >= 3,
      items >= 4,
      items >= 5
    ];
    reached.forEach(function (active, i) {
      bar.querySelectorAll('[data-step="' + (i + 1) + '"]').forEach(function (el) {
        el.classList.toggle('is-active', active);
      });
    });

    /* ── Message above bar ── */
    var msgEl = bar.querySelector('.pb-rewards__msg');
    if (msgEl) {
      var txt;
      if      (items >= 5) { txt = '🎉 20% off applied — best deal unlocked!'; }
      else if (items >= 4) { txt = '15% off applied! Add 1 more for 20% off.'; }
      else if (items >= 3) { txt = '10% off applied! Add 1 more for 15% off.'; }
      else if (items >= 2) { txt = 'Buy 1 more item to unlock 10% off!'; }
      else if (items >= 1) { txt = 'Buy 2 more items to unlock 10% off!'; }
      else                 { txt = 'Buy 3+ items to unlock up to 20% off!'; }
      msgEl.textContent = txt;
    }

    /* ── Tính giá sau discount (client-side estimate) ── */
    var estimatedTotal = totalCents;
    var estimatedSaved = 0;
    if (reward && totalCents > 0) {
      estimatedSaved = Math.round(totalCents * reward.pct / 100);
      estimatedTotal = totalCents - estimatedSaved;
    }

    /* ── Savings badge ── */
    var savEl = bar.querySelector('.pb-rewards__savings');
    if (savEl) {
      if (reward && estimatedSaved > 0) {
        savEl.style.display = '';
        var savHtml = '🎉 ' + reward.pct + '% off applied · You save $' +
          (estimatedSaved / 100).toFixed(2);
        if (savEl.textContent !== savHtml) savEl.textContent = savHtml;
      } else {
        savEl.style.display = 'none';
      }
    }

    /* ── Free shipping banner (below items) ── */
    var shipBanner = document.getElementById('pb-ship-unlocked');
    if (shipBanner) shipBanner.style.display = discTotal >= FREE_SHIP_CENTS ? '' : 'none';

    /* ── Checkout button: hiện giá ước tính sau discount ── */
    var btnPrice = document.querySelector('.cart-drawer__button-price');
    if (btnPrice && totalCents > 0) {
      var displayCents = reward ? estimatedTotal : totalCents;
      var priceTxt = '$' + (displayCents / 100).toFixed(2);
      if (btnPrice.textContent !== priceTxt) btnPrice.textContent = priceTxt;
    }

    /* ── Subtotal: gạch giá gốc + hiện giá sau discount ── */
    var subtotalOrig = document.querySelector('.pb-cart-subtotal__original');
    var subtotalDisc = document.querySelector('.pb-cart-subtotal__discounted');
    if (subtotalOrig && subtotalDisc) {
      if (reward && estimatedSaved > 0) {
        subtotalOrig.classList.add('is-crossed');
        subtotalDisc.style.display = '';
        var discTxt = '$' + (estimatedTotal / 100).toFixed(2);
        if (subtotalDisc.textContent !== discTxt) subtotalDisc.textContent = discTxt;
      } else {
        subtotalOrig.classList.remove('is-crossed');
        subtotalDisc.style.display = 'none';
      }
    }

    /* Gift sync is handled exclusively by refreshRewardsFromCart which has
       authoritative /cart.js data. updateRewardsBar only updates the UI. */

    /* ── Inject discount code into checkout link ── */
    injectDiscount(reward ? reward.code : null);
  }

  function injectDiscount(code) {
    document.querySelectorAll('a[href*="/checkout"]').forEach(function (a) {
      try {
        var url = new URL(a.href, location.origin);
        if (code) {
          url.searchParams.set('discount', code);
        } else {
          url.searchParams.delete('discount');
        }
        a.href = url.href;
      } catch (e) {}
    });
  }

  /* ── JS-layer fix: recalculate from /cart.js, excluding Gift Box from tier qty ──
     Called on every cart:refresh so AJAX updates (add/remove/qty change) always
     show the correct tier — not the tier Shopify's cart.js computes (which counts
     Gift Box toward the quantity threshold and can show a too-generous tier). */
  var _rfcTimer;
  function refreshRewardsFromCart() {
    clearTimeout(_rfcTimer);
    _rfcTimer = setTimeout(function () {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bar = document.getElementById('pb-cart-rewards');
          if (!bar) return;

          var eligibleQty  = 0;
          var displayTotal = 0;
          var origTotal    = 0;

          cart.items.forEach(function (item) {
            displayTotal += item.final_line_price;
            origTotal    += item.original_line_price;
            if (item.handle === GIFT_BOX_HANDLE || item.handle === PBB_FEE_HANDLE) return;
            eligibleQty  += item.quantity;
          });

          bar.dataset.itemCount     = eligibleQty;
          bar.dataset.cartTotal     = displayTotal;
          bar.dataset.originalTotal = origTotal;
          bar.dataset.checkoutTotal = cart.total_price;

          updateRewardsBar();
        })
        .catch(function () { updateRewardsBar(); });
    }, 100);
  }

  document.addEventListener('cart:refresh', refreshRewardsFromCart);
  document.addEventListener('cart:change',  refreshRewardsFromCart);

  /* After Prestige re-renders the drawer via AJAX, #pb-cart-rewards is a NEW
     element. Watch for it to appear in the DOM, then immediately update. */
  var rbObs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (!n.querySelector) continue;
        if (n.id === 'pb-cart-rewards' || n.querySelector('#pb-cart-rewards')) {
          /* Immediately update from Liquid-rendered dataset, then fetch for accurate totals */
          updateRewardsBar();
          refreshRewardsFromCart();
          return;
        }
      }
    }
  });
  rbObs.observe(document.body, { childList: true, subtree: true });

  /* Intercept checkout form submit to inject discount code */
  document.addEventListener('submit', function (e) {
    if (!e.target.querySelector || !e.target.querySelector('[name="checkout"]')) return;
    var bar = document.getElementById('pb-cart-rewards');
    if (!bar) return;
    var reward = getReward(parseInt(bar.dataset.itemCount) || 0);
    if (!reward) return;
    e.preventDefault();
    location.href = '/checkout?discount=' + reward.code;
  });

  /* Initial run — also retry once after 800ms in case drawer renders late */
  refreshRewardsFromCart();
  setTimeout(refreshRewardsFromCart, 800);
})();

/* Re-dispatch legacy event name — used by updatePrice() below */
document.addEventListener('variant:change', function (e) {
  document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: e.detail }));
});

/* Fix: Prestige's ProductGallery calls scrollIntoView on [data-media-id] elements
   when variant featured_media changes, causing the page to scroll up to the gallery.
   This makes elements below (like pb-product-group) appear to jump.
   Suppress that scroll — the gallery carousel handles its own internal selection. */
(function () {
  var _orig = HTMLElement.prototype.scrollIntoView;
  var _suppress = false;

  document.addEventListener('variant:change', function () {
    _suppress = true;
    setTimeout(function () { _suppress = false; }, 200);
  }, true); // capture phase — set flag before theme.js handlers run

  HTMLElement.prototype.scrollIntoView = function (options) {
    if (_suppress && this.hasAttribute && this.hasAttribute('data-media-id')) {
      return;
    }
    return _orig.call(this, options);
  };
})();

/* Reset product gallery carousel về slide đầu tiên khi load
   (Prestige tự scroll đến ảnh của default variant, cần reset lại) */
(function () {
  window.addEventListener('load', function () {
    setTimeout(function () {
      var carousel = document.querySelector('.product-gallery__carousel');
      if (!carousel) return;
      carousel.scrollLeft = 0;
    }, 200);
  });
})();

/* ========== Teeinblue: block Add to Cart until personalization done ========== */
(function () {
  var TEE_SELECTOR = '#tee-artwork-form, .teeinblue-widget';

  function isWidgetVisible() {
    var widget = document.querySelector(TEE_SELECTOR);
    if (!widget) return false;
    return widget.offsetParent !== null && getComputedStyle(widget).display !== 'none';
  }

  /* "Not personalized" = button span still reads "Personalize" (default state).
     After saving, Teeinblue changes it to "Edit Personalization" or similar.
     If the widget is hidden (non-personalizable variant), treat as already done. */
  function isPersonalized() {
    var widget = document.querySelector(TEE_SELECTOR);
    if (!widget) return true; /* no widget → no requirement */
    if (!isWidgetVisible()) return true; /* widget hidden → variant không cần personalize */
    var span = widget.querySelector('.tee-btn--personalize span');
    return !(span && span.textContent.trim().toLowerCase() === 'personalize');
  }

  /* Shake the Personalize button to guide the customer */
  function shakePersonalizeBtn() {
    var widget = document.querySelector(TEE_SELECTOR);
    if (!widget) return;
    var btn = widget.querySelector('.tee-btn--personalize');
    if (!btn) return;
    btn.style.transition = 'transform 0.08s';
    var seq = ['-7px', '7px', '-5px', '5px', '-3px', '3px', '0px'];
    seq.reduce(function (p, v) {
      return p.then(function () {
        return new Promise(function (res) {
          btn.style.transform = 'translateX(' + v + ')';
          setTimeout(res, 75);
        });
      });
    }, Promise.resolve()).then(function () { btn.style.transform = ''; });
  }

  /* Intercept product form submit in capture phase (before Prestige handles it) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    /* Skip quick-buy modals — they are separate products, not the Teeinblue product */
    if (form.closest('quick-buy-modal')) return;
    /* Only applies on product page that has a Teeinblue widget */
    if (!document.querySelector(TEE_SELECTOR)) return;
    if (!isWidgetVisible()) return; /* widget hidden → variant này không cần personalize */
    if (!isPersonalized()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      shakePersonalizeBtn();
    }
  }, true);
})();

/* ========== Teeinblue: sync Prestige cart drawer after Teeinblue ATC ========== */
(function () {
  /* Teeinblue (Vue-based) shows .tee-success inside .tee-form-responses when
     the item is successfully added to cart. This is the most reliable signal —
     we watch for that element to appear, then refresh + open Prestige's drawer. */

  var _drawerRefreshBusy = false;

  function openDrawerAfterRefresh() {
    if (_drawerRefreshBusy) return;
    _drawerRefreshBusy = true;
    setTimeout(function () { _drawerRefreshBusy = false; }, 5000);
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    var opened = false;
    var fallback = setTimeout(function () {
      drawerObs.disconnect();
      if (!opened && typeof drawer.show === 'function') {
        opened = true;
        drawer.show();
      }
    }, 3000);

    /* Watch for Prestige to finish replacing drawer HTML, then show it */
    var drawerObs = new MutationObserver(function () {
      drawerObs.disconnect();
      clearTimeout(fallback);
      if (!opened && typeof drawer.show === 'function') {
        opened = true;
        drawer.show();
      }
    });
    drawerObs.observe(drawer, { childList: true, subtree: true });

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* Watch for .tee-success appearing — Vue inserts it on successful ATC */
  var bodyObs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        var isSuccess = (node.classList && node.classList.contains('tee-success'))
          || (node.querySelector && node.querySelector('.tee-success'));
        if (isSuccess) {
          openDrawerAfterRefresh();
          return;
        }
      }
    }
  });

  bodyObs.observe(document.body, { childList: true, subtree: true });
})();

/* ========== Teeinblue: auto-sync first name to subsequent name inputs ========== */
(function () {
  let boundTrigger = null;

  function setup() {
    const inputs = Array.from(document.querySelectorAll('input.tee__input--text'));
    if (inputs.length < 2) return false;

    const trigger = inputs[0];
    if (boundTrigger === trigger) return true;
    boundTrigger = trigger;

    const targets = inputs.slice(1);

    function syncTargets() {
      const v = trigger.value;
      targets.forEach(function (target) {
        if (!target._mozModified) {
          target.value = v;
          target.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }

    trigger.addEventListener('input', syncTargets);

    targets.forEach(function (target) {
      // Mark as user-modified when user types their own value
      target.addEventListener('input', function (e) {
        if (e.isTrusted) target._mozModified = true;
      });
      // Clear the flag when target is emptied so it syncs again
      target.addEventListener('blur', function () {
        if (!target.value.trim()) target._mozModified = false;
      });
    });

    return true;
  }

  // Watch for variant switches that replace inputs
  const obs = new MutationObserver(function (mutations) {
    const hasNewInputs = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 &&
          (n.matches('input.tee__input--text') ||
           (n.querySelector && n.querySelector('input.tee__input--text')));
      });
    });
    if (hasNewInputs) {
      boundTrigger = null;
      setTimeout(setup, 150);
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  if (!setup()) {
    let tries = 0;
    const timer = setInterval(function () {
      if (setup() || ++tries > 50) clearInterval(timer);
    }, 200);
  }
})();

/* ── MOZIGO Personalization System ── */
(function () {
  'use strict';

  var FEE_VARIANTS = {
    500:  44831456559174
  };

  var COOLDOWN_MS = 3000;
  var _fetch      = window.fetch;
  var isAdding    = false;
  var lastAddTime = 0;

  function money(c)  { return '$' + (c / 100).toFixed(2); }
  function qs(s, r)  { return (r || document).querySelector(s); }
  function qsa(s, r) { return (r || document).querySelectorAll(s); }
  function genId()   { return 'pz_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6); }

  function feeVid(cents) {
    if (cents <= 0) return null;
    return FEE_VARIANTS[cents] || null;
  }

  function customText(block) {
    var p = [];
    var f = document.getElementById('pb-prop-firstname');
    var l = document.getElementById('pb-prop-lastname');
    if (f && f.value.trim()) p.push(f.value.trim());
    if (l && l.value.trim()) p.push(l.value.trim());
    if (p.length === 0) {
      var panel = qs('.mozigo-personalizer__panel', block);
      if (panel) {
        qsa('input[type="text"], textarea, select', panel).forEach(function (el) {
          if (el.value && el.value.trim()) p.push(el.value.trim());
        });
      }
    }
    return p.join(' ') || 'Custom';
  }

  /* Default sort: Date new→old on collection pages without explicit sort_by */
  (function () {
    if (window.location.pathname.indexOf('/collections/') === -1) return;
    var params = new URLSearchParams(window.location.search);
    if (!params.has('sort_by')) {
      params.set('sort_by', 'created-descending');
      window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
    }
  })();

  function initMozigo() {
    qsa('.mozigo-personalizer').forEach(function (block) {
      if (block.dataset.mozigoInit) return;
      block.dataset.mozigoInit = '1';

      var cb      = qs('.mozigo-personalizer__checkbox', block);
      var panel   = qs('.mozigo-personalizer__panel', block);
      var flag    = qs('.mozigo-personalizer__flag-input', block);
      var fee     = qs('.mozigo-personalizer__fee-input', block);
      var badge   = qs('.mozigo-personalizer__badge', block);
      var pzInput = qs('.mozigo-personalizer__pzid-input', block);
      var cents   = parseInt(block.dataset.addonCents, 10) || 0;
      var hasFee  = cents > 0;

      if (!cb) return;

      if (!hasFee && pzInput) pzInput.value = genId();

      var row = qs('.mozigo-personalizer__toggle-row', block);
      if (row) {
        row.addEventListener('click', function (e) {
          if (e.target.closest('.mozigo-personalizer__switch')) return;
          cb.checked = !cb.checked;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      cb.addEventListener('change', function () {
        var on = cb.checked;
        if (panel) {
          if (on) {
            panel.removeAttribute('hidden');
            panel.setAttribute('aria-hidden', 'false');
            requestAnimationFrame(function () { panel.classList.add('is-open'); });
          } else {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
            setTimeout(function () { if (!cb.checked) panel.setAttribute('hidden', ''); }, 350);
          }
        }
        if (flag)    flag.value    = on ? 'Yes' : '';
        if (fee)     fee.value     = on && hasFee ? cents : '';
        if (pzInput) pzInput.value = on ? genId() : '';
        if (badge)   badge.style.display = (on && hasFee) ? 'inline-flex' : 'none';
        if (panel) {
          qsa('input, textarea, select', panel).forEach(function (el) {
            if (el.type === 'hidden') return;
            el.disabled = !on;
            if (!on) { if (el.type === 'checkbox' || el.type === 'radio') el.checked = false; else el.value = ''; }
          });
        }
        updatePrice();
      });

      var formId = flag ? flag.getAttribute('form') : null;
      if (formId) {
        var form = document.getElementById(formId);
        var btn  = form ? qs('[type="submit"]', form) : qs('button[form="' + formId + '"]');
        var textInput = qs('.mozigo-personalizer__text-input', block);
        if (btn) {
          btn.addEventListener('click', function () {
            if (cb.checked) {
              if (pzInput) pzInput.value = genId();
              if (textInput) textInput.value = customText(block);
            }
          }, true);
        }
        if (form) {
          form.addEventListener('submit', function () {
            if (cb.checked) {
              if (pzInput && (!pzInput.value || !pzInput.value.startsWith('pz_'))) pzInput.value = genId();
              if (textInput) textInput.value = customText(block);
            }
          }, true);
        }
      }
    });
  }

  function updatePrice() {
    var el = qs('.price-list sale-price .text-lg, .price-list .price, [data-product-price]');
    var id = qs('select[name="id"], input[name="id"]');
    var json = qs('[data-product-json], script[data-product-id]');
    if (!el || !id || !json) return;
    var addon = 0;
    qsa('.mozigo-personalizer').forEach(function (b) {
      var c = qs('.mozigo-personalizer__checkbox', b);
      if (c && c.checked) addon += parseInt(b.dataset.addonCents, 10) || 0;
    });
    try {
      var v = JSON.parse(json.textContent).variants.find(function (v) { return String(v.id) === String(id.value); });
      if (v) el.innerHTML = money(v.price + addon);
    } catch (e) {}
  }

  document.addEventListener('variant:changed', updatePrice);
  document.addEventListener('product:variant-changed', updatePrice);

  window.fetch = function (url, opts) {
    var result = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/add') && !isAdding) {
      result.then(function (r) { return r.clone().json(); }).then(onCartAdd).catch(function () {});
    }
    return result;
  };

  function onCartAdd(data) {
    var now = Date.now();
    if (now - lastAddTime < COOLDOWN_MS) return;
    var cb = qs('.mozigo-personalizer .mozigo-personalizer__checkbox:checked');
    if (!cb) return;
    var block = cb.closest('.mozigo-personalizer');
    var cents = parseInt(block.dataset.addonCents, 10) || 0;
    var fee   = feeVid(cents);
    if (!fee) return;
    var item = data.items ? data.items[0] : data;
    if (!item || !item.variant_id) return;
    if (item.properties && item.properties['_fee_for']) return;
    var pzId = (item.properties && item.properties['_pz_id']) || null;
    if (!pzId) { var pzInput = qs('.mozigo-personalizer__pzid-input', block); pzId = pzInput ? pzInput.value : genId(); }
    lastAddTime = now;
    isAdding = true;
    _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: fee, quantity: 1, properties: { '_fee_for': 'Personalization', '_pz_id': pzId, '_linked_variant': String(item.variant_id), '_custom_text': customText(block) } }] })
    }).then(function (r) { if (!r.ok) throw new Error('Fee add failed'); return refreshDrawer(); })
      .catch(function (e) { console.error('MOZIGO:', e); })
      .finally(function () { isAdding = false; });
  }

  function refreshDrawer() {
    return _fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var el   = document.getElementById('cart-drawer');
        if (html && el) { var t = document.createElement('div'); t.innerHTML = html; var d = t.querySelector('cart-drawer'); if (d) el.innerHTML = d.innerHTML; }
        return _fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        qsa('.cart-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        qsa('.cart-drawer__button-price').forEach(function (el) { el.textContent = money(c.total_price); });
      })
      .catch(function () { window.location.reload(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMozigo);
  } else {
    initMozigo();
  }
})();